import React, { useEffect, useState } from 'react';
import { get } from '../../utils/api';
import { Link, useLocation } from 'react-router-dom';

import { arrow, downLogo, blogLogo, mainLogo, spLogo, referenceLogo } from '../../assets/images/header/headerImages';

import './Header.css';

const Header = () => {

  const [openIndex, setOpenIndex] = useState(null);
  const [isMenuVisible, setMenuVisible] = useState(false);
  const [prdData, setPrdData] = useState([]);
  
  const handleMouseOver = (index) => {
    setOpenIndex(index);
    setMenuVisible(true);
  };

  const handleMouseOut = () => {
    setOpenIndex(null);
    setMenuVisible(false);
  };

  const handleLinkClick = () => {
    setMenuVisible(false);
  };
  
  useEffect(() => {
    const prdSideData = async() => {
        try{
            const res = await get('/product/prdside');
            setPrdData(res);
        } catch(err) {
            console.log(err);
        };
    };
    prdSideData();
  }, []);

  const location = useLocation();
  const currentPathname = location.pathname;

  return (
    <>
      <div className='header'>
        <div className='inner-container'>
          <div id='headerContent'>
            <Link className='text-line-none flex-row center' to={'https://rfemfo.co.kr/uploads/reference/file/bro_down.pdf'} target='_blank'>
              <div id='spIconDiv'>
                <img id='downIcon' src={downLogo} alt='제품소개서' />
              </div>
              <div className='headerSmallText'>제품소개서</div>
            </Link>
            <div id='headerConLine'></div>
            <Link className='text-line-none flex-row center' to={'https://rfemfo.co.kr/support/reference'} target='_blank'>
              <div id='spIconDiv'>
                <img id='referenceIcon' src={referenceLogo} alt='자료실' />
              </div>
              <div className='headerSmallText'>자료실</div>
            </Link>                
            <div id='headerConLine'></div>
            <Link className='text-line-none flex-row center' to={'https://mkt.shopping.naver.com/link/682a902c814c2c37cf005fcb'} target='_blank'>
              <div id='spIconDiv'>
                <img id='spIcon' src={spLogo} alt='쇼핑몰' />
              </div>
              <div className='headerSmallText'>쇼핑몰</div>
            </Link>            
            <div id='headerConLine'></div>
            <Link className='text-line-none flex-row center' to={'https://blog.naver.com/PostList.naver?blogId=emfosky&from=postList&categoryNo=11'} target='_blank'>
              <div>
                <img id='blogIcon' src={blogLogo} alt='블로그' />
              </div>
              <div className='headerSmallText'>블로그</div>
            </Link>
          </div>
          <div id='menu-background' className={(openIndex || openIndex === 0) && isMenuVisible ? 'show' : ''}></div>
          <div>
            <ul id='navMenu'>
              <div id='headerLogo'>
                <Link to={'/'} onClick={(e)=>{
                      if(currentPathname === '/'){
                        e.preventDefault();
                        window.location.reload();
                      }
                    }}>
                  <img src={mainLogo} id='mainLogo' alt='mainLogo'></img>
                </Link>
              </div>
              <li onMouseOver={() => handleMouseOver(0)} onMouseOut={handleMouseOut}>
                <Link to={'/company/info'} className='menu-link'>COMPANY</Link> 
                  <ul className={`header-sub-menu ${openIndex === 0 ? 'active' : ''} ${(openIndex || openIndex === 0) && isMenuVisible ? 'show' : ''}`}>
                    <li></li>
                    <Link to={'/company/info'} className='sub-menu-link' onClick={(e)=>{
                      if(currentPathname === '/company/info'){
                        e.preventDefault();
                        window.location.reload();
                      }
                    }} >
                      <li>회사개요</li>
                    </Link>
                    <Link to={'/company/ceo'} className='sub-menu-link' onClick={(e)=>{
                      if(currentPathname === '/company/ceo'){
                        e.preventDefault();
                        window.location.reload();
                      }
                    }}>
                      <li>CEO 인사말</li>
                    </Link>
                    <Link to={'/company/history'} className='sub-menu-link' onClick={(e)=>{
                      if(currentPathname === '/company/history'){
                        e.preventDefault();
                        window.location.reload();
                      }
                    }}>
                      <li>연혁</li>
                    </Link>
                    <Link to={'/company/certList'} className='sub-menu-link' onClick={(e)=>{
                      if(currentPathname === '/company/certList'){
                        e.preventDefault();
                        window.location.reload();
                      }
                    }}>
                      <li>인증현황</li>
                    </Link>
                    <Link to={'/company/ci'} className='sub-menu-link' onClick={(e)=>{
                      if(currentPathname === '/company/ci'){
                        e.preventDefault();
                        window.location.reload();
                      }
                    }}>
                      <li>CI소개</li>
                    </Link>
                    <Link to={'/company/way'} className='sub-menu-link' onClick={(e)=>{
                      if(currentPathname === '/company/way'){
                        e.preventDefault();
                        window.location.reload();
                      }
                    }}>
                      <li>오시는 길</li>
                    </Link>
                  </ul>
              </li>
              <li onMouseOver={() => handleMouseOver(1)} onMouseOut={handleMouseOut}>
                <Link to={'/rfid-nfc/info'} className='menu-link'>RFID / NFC</Link> 
                <ul className={`header-sub-menu ${openIndex === 1 ? 'active' : ''} ${(openIndex || openIndex === 0) && isMenuVisible ? 'show' : ''}`}>
                  <li></li>
                  <Link to={'/rfid-nfc/info'} className='sub-menu-link' onClick={(e)=>{
                      if(currentPathname === '/rfid-nfc/info'){
                        e.preventDefault();
                        window.location.reload();
                      }
                    }}>
                    <li>RFID/NFC 개요</li>
                  </Link>
                  <Link to={'/rfid-nfc/chip'} className='sub-menu-link' onClick={(e)=>{
                      if(currentPathname === '/rfid-nfc/chip'){
                        e.preventDefault();
                        window.location.reload();
                      }
                    }}>
                    <li>CHIP 종류</li>
                  </Link>
                </ul>
              </li>
              <li onMouseOver={() => handleMouseOver(2)} onMouseOut={handleMouseOut} id='productHeader'>
                <Link to={'/product/list?list=1&pageIdx=1'} className='menu-link'>PRODUCT</Link> 
                <ul className={`header-sub-menu ${openIndex === 2 ? 'active' : ''} ${(openIndex || openIndex === 0) && isMenuVisible ? 'show' : ''}`}>
                  <li></li>
                  {prdData.map((item, index) => {
                    const div2Array = item.DIV_2.split(', ').map((div2Item) => {
                      const [seq, name] = div2Item.replace(/[{}]/g, '').split(':');
                      return { seq, name };
                    });

                    const firstSeq = div2Array[0]?.seq;

                    return (
                      <Link
                        key={item.DIV_1_SEQ}
                        to={item.DIV_1_SEQ === 1 ? '/product/list?list=1&pageIdx=1' : `/product/list?list=${firstSeq}&pageIdx=1`}
                        className='sub-menu-link'
                        onClick={handleLinkClick}
                      >
                        <li>{item.DIV_1_NAME}</li>
                      </Link>
                    );
                  })}
                </ul>
              </li>
              <li onMouseOver={() => handleMouseOver(3)} onMouseOut={handleMouseOut}>
                <Link to={'/solution/attend'} className='menu-link'>SOLUTION</Link> 
                <ul className={`header-sub-menu ${openIndex === 3 ? 'active' : ''} ${(openIndex || openIndex === 0) && isMenuVisible ? 'show' : ''}`}>
                  <li></li>
                  <Link to={'/solution/attend'} className='sub-menu-link' onClick={(e)=>{
                      if(currentPathname === '/solution/attend'){
                        e.preventDefault();
                        window.location.reload();
                      }
                    }}>
                    <li>근태관리솔루션</li>
                  </Link>
                  <Link to={'/solution/school'} className='sub-menu-link' onClick={(e)=>{
                      if(currentPathname === '/solution/school'){
                        e.preventDefault();
                        window.location.reload();
                      }
                    }}>
                    <li>등하원관리솔루션</li>
                  </Link>
                  <Link to={'/solution/nfc'} className='sub-menu-link' onClick={(e)=>{
                      if(currentPathname === '/solution/nfc'){
                        e.preventDefault();
                        window.location.reload();
                      }
                    }}>
                    <li>NFC 인코딩솔루션</li>
                  </Link>
                  <Link to={'/solution/rfid'} className='sub-menu-link' onClick={(e)=>{
                      if(currentPathname === '/solution/rfid'){
                        e.preventDefault();
                        window.location.reload();
                      }
                    }}>
                    <li>RFID R/W 솔루션</li>
                  </Link>
                  <Link to={'/solution/tag'} className='sub-menu-link' onClick={(e)=>{
                      if(currentPathname === '/solution/tag'){
                        e.preventDefault();
                        window.location.reload();
                      }
                    }}>
                    <li>900Mhz 인코딩 솔루션</li>
                  </Link>
                  <Link to={'/solution/cardprint'} className='sub-menu-link' onClick={(e)=>{
                      if(currentPathname === '/solution/cardprint'){
                        e.preventDefault();
                        window.location.reload();
                      }
                    }}>
                    <li>RFID/NFC 카드인쇄</li>
                  </Link>                      
                </ul>
              </li>
              <li onMouseOver={() => handleMouseOver(4)} onMouseOut={handleMouseOut}>
                <Link to={'/portfolio/partner/1'} className='menu-link'>PORTFOLIO</Link> 
                <ul className={`header-sub-menu ${openIndex === 4 ? 'active' : ''} ${(openIndex || openIndex === 0) && isMenuVisible ? 'show' : ''}`}>
                  <li></li>
                  <Link to={'/portfolio/partner/1'} className='sub-menu-link' onClick={(e)=>{
                      if(currentPathname === '/portfolio/partner/1'){
                        e.preventDefault();
                        window.location.reload();
                      }
                    }}>
                    <li>주요납품 소개</li>
                  </Link>
                  <Link to={'/portfolio/delivery/1'} className='sub-menu-link' onClick={(e)=>{
                      if(currentPathname === '/portfolio/delivery/1'){
                        e.preventDefault();
                        window.location.reload();
                      }
                    }}>
                    <li>납품 갤러리</li>
                  </Link>
                </ul>
              </li>
              <li onMouseOver={() => handleMouseOver(5)} onMouseOut={handleMouseOut}>
                <Link to={'/support/notice/1'} className='menu-link'>SUPPORT</Link> 
                <ul className={`header-sub-menu header-border-right ${openIndex === 5 ? 'active' : ''} ${(openIndex || openIndex === 0) && isMenuVisible ? 'show' : ''}`}>
                  <li></li>
                  <Link to={'/support/notice/1'} className='sub-menu-link' onClick={(e)=>{
                      if(currentPathname === '/support/notice/1'){
                        e.preventDefault();
                        window.location.reload();
                      }
                    }}>
                    <li>공지사항</li>
                  </Link>
                  <Link to={'/support/inquiry/1'} className='sub-menu-link' onClick={(e)=>{
                      if(currentPathname === '/support/inquiry/1'){
                        e.preventDefault();
                        window.location.reload();
                      }
                    }}>
                    <li>온라인 문의</li>
                  </Link>
                  <Link to={'/support/buy'} className='sub-menu-link' onClick={(e)=>{
                      if(currentPathname === '/support/buy'){
                        e.preventDefault();
                        window.location.reload();
                      }
                    }}>
                    <li>결제 하기</li>
                  </Link>
                  <Link to={'/support/remote'} className='sub-menu-link' onClick={(e)=>{
                      if(currentPathname === '/support/remote'){
                        e.preventDefault();
                        window.location.reload();
                      }
                    }}>
                    <li>원격 지원</li>
                  </Link>
                  <Link to={'/support/reference'} className='sub-menu-link' onClick={(e)=>{
                      if(currentPathname === '/support/reference'){
                        e.preventDefault();
                        window.location.reload();
                      }
                    }}>
                    <li>자료실</li>
                  </Link>
                </ul>
              </li>
            </ul>
          </div>
        </div>
        <div id='headerLine'></div>
      </div>


    </>
  );
};

export default Header;